// contexts/voice/constants.ts
// All magic numbers and configuration constants

export const VOICE_CONSTANTS = {
  // Audio settings
  AUDIO_SAMPLE_RATE_INPUT: 16000,   // Microphone capture rate (Hz)
  AUDIO_SAMPLE_RATE_OUTPUT: 24000,  // Playback rate from Gemini (Hz)
  AUDIO_BUFFER_SIZE: 4096,          // ScriptProcessorNode buffer size
  AUDIO_CHANNELS: 1,                // Mono audio

  // AudioStreamer settings (from Google's implementation)
  STREAMER_BUFFER_SIZE: 7680,       // Audio queue buffer size
  STREAMER_INITIAL_BUFFER_TIME: 0.1, // Initial buffer time (seconds)
  STREAMER_SCHEDULE_AHEAD_TIME: 0.2, // How far ahead to schedule audio (seconds)
  STREAMER_CHECK_INTERVAL: 100,     // Queue check interval (ms)
  STREAMER_FADE_TIME: 0.1,          // Fade out time on stop (seconds)

  // Timeouts (in milliseconds)
  HIGHLIGHT_TIMEOUT_MS: 10000,      // Product highlight duration
  PTT_HINT_TIMEOUT_MS: 1500,        // Push-to-talk hint display
  DEBOUNCE_ADD_TO_CART_MS: 2000,    // Prevent duplicate cart adds
  HANDOVER_DELAY_MS: 3000,          // Delay before handover completes

  // WebSocket endpoints
  WS_VOICE_ENDPOINT: 'ws/voice',
  WS_TEXT_ENDPOINT: 'ws/text',

  // LocalStorage keys
  STORAGE_KEY_VOICE: 'selected_voice',
  STORAGE_KEY_VAD_MODE: 'selected_vad_mode',
} as const;

// Default agent info
export const DEFAULT_AGENT: { name: string; type: 'ai' | 'human'; role: string } = {
  name: 'Sophie',
  type: 'ai',
  role: 'AI Assistent',
};
